import React, { ReactNode } from 'react'

import { VscChevronDown, VscChevronUp } from 'react-icons/vsc'

import { Routines } from '..'
import { useUser } from '../../../../../../context'

import {
  AccordionContainer,
  AccordionContent,
  AccordionHeader,
  AccordionItem,
} from './styles'

const RoutinesAccordion = ({
  routines,
  handleToggleAccordion,
  openIndex,
  children,
}: {
  routines: Routines[]
  handleToggleAccordion: (index: number) => void
  openIndex: number | null
  children: ReactNode
}) => {
  const { userRole } = useUser()
  return (
    <AccordionContainer $userType={userRole} style={{ padding: '0' }}>
      {routines.map((routine, idx) => (
        <AccordionItem key={idx}>
          <AccordionHeader
            onClick={() => handleToggleAccordion(idx)}
            $userType={userRole}
            $isOpen={openIndex === idx}
          >
            {routine.category}
            {openIndex === idx ? <VscChevronUp /> : <VscChevronDown />}
          </AccordionHeader>
          <AccordionContent $isOpen={openIndex === idx}>
            {openIndex === idx && children}
          </AccordionContent>
        </AccordionItem>
      ))}
    </AccordionContainer>
  )
}

export default RoutinesAccordion
